<template>
  <SpicyBowlsBody />
</template>

<script>
import SpicyBowlsBody from '../molecules/SpicyBowlsBody.vue'


export default {
  name: 'SpicyBowlsView',
  components: {
    SpicyBowlsBody,
  }
}
</script>
